<template>
  <div class="centerCenter">
    <div class="container text-center">
      <img class="mb-4" alt="TopQuiz logo" src="../assets/logo_200.png" />
      <h1>Welcome to TopQuiz!</h1>
      <div class="row justify-content-center">
        <h4 class="col-12 form-signin-heading pb-2 text-secondary topquizWit">
          Your #1 choice in online pub quiz scoring apps!
        </h4>

        <router-link class="col-12 mt-2" to="/about"
          >What is TopQuiz?</router-link
        >

        <div class="col-12 my-3">
          <Calendar variant="center" title="Upcoming quizzes" />
        </div>
        <div class="col-md-3 col-6 mt-3">
          <router-link
            to="./register"
            class="btn btn-lg btn-secondary btn-block"
            >Sign up</router-link
          >
        </div>
        <div class="col-md-3 col-6 mt-3">
          <router-link to="/login" class="btn btn-lg btn-primary btn-block"
            >Sign in</router-link
          >
        </div>
      </div>

      <slot name="footer"></slot>
    </div>
    <!-- /container -->
  </div>
</template>

<script>
import Calendar from "@/components/Calendar";

export default {
  name: "Home",
  components: {
    Calendar
  },
  created() {
    this.$emit("toggle-navbar", false);
    this.$emit("full-body", true);
  }
};
</script>

<style scoped></style>
